import React, { Component } from 'react'
import { connect } from 'react-redux'

// Styles
import './index.scss'

// Utils
import { translation, enumtranslate } from '../../../../../utils/helpers'

// Elements
import LabelWrapper from '../../../../../shared/elements/labelWrapper'
import Inline from '../../../../../shared/elements/inline'
import PanelHeader from '../../../../../shared/elements/panelHeader'
import Grid from '../../../../../shared/elements/grid'
import Label from '../../../../../shared/elements/label'

class Transport extends Component {

  renderReferredOut () {
    return (
      <div>
        <PanelHeader text={translation('751')} />
        <LabelWrapper labelText={translation('705') + ':'}>
          {this.props.item.OrderConnection.TransportBefore}
        </LabelWrapper>
        <LabelWrapper labelText={translation('707') + ':'}>
          {this.props.item.OrderConnection.TransportAfter}
        </LabelWrapper>
        <Grid>
          <div>{translation('729')}: </div>
          {this.props.item.OrderConnection.TransferedToCompanyName}
        </Grid>
        <Grid>
          <div>{translation('359')}: </div>
          {translation(enumtranslate('PaintShopOrderSteps', this.props.item.OrderConnection.StepId))}
        </Grid>
        {!this.props.item.OrderConnection.IsApproved && (
          <Label>{translation('734')}</Label>
        )}
      </div>
    )
  }
  renderReferredIn () {
    return (
      <div>
        <PanelHeader text={translation('751')} />
        <LabelWrapper labelText={translation('705') + ':'}>
          {this.props.item.OrderConnection.TransportBefore}
        </LabelWrapper>
        <LabelWrapper labelText={translation('707') + ':'}>
          {this.props.item.OrderConnection.TransportAfter}
        </LabelWrapper>
        <Grid>
          <div>{translation('719')}: </div>
          {this.props.item.OrderConnection.TransferedFromCompanyName}
        </Grid>
        <Grid>
          <div>{translation('359')}: </div>
          {translation(enumtranslate('PaintShopOrderSteps', this.props.item.OrderConnection.StepId))}
        </Grid>
        {!this.props.item.OrderConnection.IsApproved && (
          <Label className='left bold'>{translation('734')}</Label>
        )}
      </div>
    )
  }

  RenderBodyShopPickUp () {
    let { BodyShopPickupAltLocation } = this.props.item

    if (this.props.item.HasBodyShopPickupAltLocation !== false) {
      if (this.props.item.BodyShopPickupAltLocationId === 0 && BodyShopPickupAltLocation === null) {
        return (
          <LabelWrapper labelText={translation('157')}>
            {translation('227')}<br />
            {this.props.item.BodyShopPickupAltLocationComment}
          </LabelWrapper>
        )
      } else {
        if (BodyShopPickupAltLocation !== null) {
          return (
            <LabelWrapper labelText={translation('157')}>
              {BodyShopPickupAltLocation.Name}<br />
              {BodyShopPickupAltLocation.Address}, {BodyShopPickupAltLocation.ZipCode} {BodyShopPickupAltLocation.City}
            </LabelWrapper>
          )
        }
      }
    }
  }

  RenderBodyShopDelivery () {
    let { BodyShopDeliveryAltLocation } = this.props.item
    if (this.props.item.HasBodyShopDeliveryAltLocation !== false) {
      if (this.props.item.BodyShopDeliveryAltLocationId === 0 && BodyShopDeliveryAltLocation === null) {
        return (
          <LabelWrapper labelText={translation('193')}>
            {translation('227')}<br />
            {this.props.item.BodyShopDeliveryAltLocationComment}
          </LabelWrapper>
        )
      } else {
        if (BodyShopDeliveryAltLocation !== null) {
          return (
            <LabelWrapper labelText={translation('193')}>
              {BodyShopDeliveryAltLocation.Name}<br />
              {BodyShopDeliveryAltLocation.Address}, {BodyShopDeliveryAltLocation.ZipCode} {BodyShopDeliveryAltLocation.City}
            </LabelWrapper>
          )
        }
      }
    }
  }

  render () {
    if (this.props.auth.departmentType === 1) {
      return (
        <div className='poppedup padding TransportInlinePopup'>
          {this.RenderBodyShopPickUp()}
          {this.RenderBodyShopDelivery()}
          {/* this.props.item.IsReferredOut && this.renderReferredOut() */}
          {/* this.props.item.IsReferredIn && this.renderReferredIn() */}
        </div>
      )
    } else {
      let { PickupAltLocation, DeliveryAltLocation } = this.props.item
      return (
        <div className='poppedup padding TransportInlinePopup'>
          {PickupAltLocation !== null && (
            <LabelWrapper labelText={translation('157')}>
              {PickupAltLocation.Name}
              <Inline block>{PickupAltLocation.Address + ','}{PickupAltLocation.ZipCode}{PickupAltLocation.City}</Inline>
            </LabelWrapper>
          )}
          {DeliveryAltLocation !== null && (
            <LabelWrapper labelText={translation('193')}>
              {DeliveryAltLocation.Name}
              <Inline block>{DeliveryAltLocation.Address + ','}{DeliveryAltLocation.ZipCode}{DeliveryAltLocation.City}</Inline>
            </LabelWrapper>
          )}
          {this.props.item.IsReferredIn && this.props.item.OrderConnection !== null && this.renderReferredIn()}
          {this.props.item.IsReferredOut && this.props.item.OrderConnection !== null && this.renderReferredOut()}
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(Transport)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Transport/index.js